/* @flow */
import * as React from 'react';

import GroupAvatar from 'groups/components/GroupAvatar';
import type { Props as GroupAvatarProps } from 'groups/components/GroupAvatar';

import getField from '../ComposableTableField';
import type { Field } from '../ComposableTableField';

export function getGroupAvatarCellGenerator(input: {
  fieldForAction?: Field,
  groupField?: Field,
  onClickAction?: (SyntheticEvent<>, any) => void,
  groupAvatarProps?: $Shape<GroupAvatarProps>,
}) {
  const { fieldForAction, groupAvatarProps, groupField, onClickAction } = input;

  return (data: Object) => {
    return (
      <GroupAvatar
        {...groupAvatarProps}
        group={getField(data, groupField)}
        size="small"
        onClick={e => onClickAction && onClickAction(e, getField(data, fieldForAction))}
      />
    );
  };
}
